import { defineStore } from "pinia";

export const useMegStore = defineStore("usemessage", {
  state: () => ({
    acitveTagsName: "/home",
    menuList: [], //侧边栏菜单
    tagsList: [
      {
        title: "首页",
        path: "/home",
        icon: "Compass",
      },
    ], //快捷切换tags
    role: {},
    // 需要缓存的页面组件名称列表
    cachedViews: [],
  }),
  actions: {
    // 设置菜单
    setMenusList(menus) {
      this.menuList = menus;
    },
    // 设置头部切换 tags
    setTagsList(tags) {
      let tagsIndex = this.tagsList.findIndex((item) => item.path == tags.path);
      if (tagsIndex == -1) {
        this.tagsList.push(tags);
      }
    },
    // 删除头部的tags
    removeTagsList(tags) {
      let tagsIndex = this.tagsList.findIndex((item) => item.path == tags);
      if (tags != -1) {
        this.tagsList.splice(tagsIndex, 1);
        if (this.tagsList.length == 0) {
          this.tagsList.push({
            title: "首页",
            path: "/home",
            icon: "Compass",
          });
        }
      }
    },
    //设置当期tags选中
    setAcitveTagsName(tagsName) {
      this.acitveTagsName = tagsName;
    },
    // 添加缓存页面
    addCachedView(viewName) {
      if (!this.cachedViews.includes(viewName)) {
        this.cachedViews.push(viewName);
      }
    },
    // 移除缓存页面
    removeCachedView(viewName) {
      const index = this.cachedViews.indexOf(viewName);
      if (index > -1) {
        this.cachedViews.splice(index, 1);
      }
    },
    // 清除所有缓存
    clearCachedViews() {
      this.cachedViews = [];
    },
  },
});
